export const NewNavHandlers = () => {
    const headers = document.querySelectorAll<HTMLElement>(".new-main-header");

    headers.forEach((header) => {
        wrapNavLi(header);
        backButtonClickHandler(header);
        OpenMobileNav(header);
        repositionNavBanners(header);
        setHeaderActive(header);
        iconClickHandler(header);
    });
};

export const repositionNavBanners = (header) => {
    // Wait for window to load to ensure all elements are rendered
    window.addEventListener("load", () => {
        // Select all main navigation root items that may have banners
        const rootNavItems = header.querySelectorAll(
            ".new-main-header__navigation .navRoot > li"
        );

        rootNavItems.forEach((navItem) => {
            // Find banner container within this nav item - fixed the invalid selector
            const banner = navItem.querySelector(
                ".text-node .nav-banner-container"
            );

            if (banner) {
                // Find the corresponding navLevel-1 for this nav item - fixed the invalid selector
                const navLevel1 = navItem.querySelector(".navLevel-1");

                if (navLevel1) {
                    // Remove banner from current location
                    banner.remove();

                    // Insert at the beginning of navLevel-1
                    navLevel1.insertBefore(banner, navLevel1.firstChild);

                    // Make sure the banner is visible
                    banner.classList.add('safe');
                }
            }
        });
    });
};

export const OpenMobileNav = (header: HTMLElement): void => {
    const burger = header.querySelector<HTMLButtonElement>(
        ".new-main-header__burger-menu"
    );
    const navigation = header.querySelector<HTMLDivElement>(
        ".new-main-header__navigation"
    );
    const body = document.querySelector<HTMLBodyElement>("body");

    if (!burger || !navigation || !body) return;

    burger.addEventListener("click", () => {
        navigation.classList.toggle("open");
        burger.classList.toggle("burger-open");
        body.classList.toggle("nav-open");
        CloseOpenNavs(navigation);
    });
};

export const wrapNavLi = (nav: HTMLElement) => {
    const navLevel1: NodeListOf<HTMLElement> =
        nav.querySelectorAll(".navLevel-1");

    navLevel1.forEach((navLevel) => {
        const wrapper = document.createElement("div");
        const linkWrapper = document.createElement("UL");
        const actionButtonWrapper = document.createElement("div");

        linkWrapper.classList.add("links");
        wrapper.classList.add("inner-nav-wrapper");
        actionButtonWrapper.classList.add("action-button-wrapper");

        // Create a H3 that has the parent link text
        const navSectionHeading = document.createElement("h3");
        const closestLi = navLevel.closest("li");
        const textContent = closestLi?.querySelector(".text")?.textContent ?? closestLi?.querySelector(".text-node")?.textContent ?? null;
        navSectionHeading.textContent = textContent;
        navSectionHeading.classList.add("nav-section-heading");

        const listItems = Array.from(navLevel.children).filter(
            (child) => child.tagName === "LI"
        );

        listItems.forEach((item) => {
            linkWrapper.appendChild(item);
        });
        
        wrapper.appendChild(linkWrapper);
        navLevel.appendChild(navSectionHeading);
        navLevel.appendChild(wrapper);
    });

    const root = nav.querySelector(".navRoot");

    if (root) {
        const rootLi = root.querySelectorAll("li");
        const actionButtonWrapper = document.createElement("div");
        actionButtonWrapper.classList.add("action-button-wrapper");

        rootLi.forEach((li) => {
            if (
                li.classList.contains("search-overlay-trigger") ||
                li.classList.contains("action-button")
            ) {
                actionButtonWrapper.appendChild(li);
            }
        });

        if (actionButtonWrapper.children.length > 0) {
            root.appendChild(actionButtonWrapper);
        }
    }
};


export const iconClickHandler = (nav: HTMLElement) => {
    const icons = nav.querySelectorAll<HTMLElement>(".icon");

    icons.forEach((icon) => {
        icon.addEventListener("click", () => {
            const parentLi = icon.closest("li");
            const nearestNavList = parentLi?.querySelector(".navList");

            if (nearestNavList) {
                // Close all open navigations in siblings before toggling current item
                const parentUl = parentLi?.parentElement;
                if (parentUl) {
                    // Find all sibling li elements that have open navigation
                    const siblingLis = parentUl.querySelectorAll<HTMLElement>("li");
                    siblingLis.forEach((siblingLi) => {
                        if (siblingLi !== parentLi) {
                            // Close any open descendants in this sibling
                            CloseOpenNavs(siblingLi);
                            // Remove active state from sibling
                            siblingLi.classList.remove("is-active");
                        }
                    });
                }

                // Toggle the current navigation item
                nearestNavList.classList.toggle("open");
                parentLi?.classList.toggle("is-active");
            } else {
                console.warn("No nearest navList found for icon:", icon);
            }
        });
    });
};

export const backButtonClickHandler = (nav: HTMLElement) => {
    const backButtons = nav.querySelectorAll<HTMLElement>(".nav-back-btn");

    backButtons.forEach((button) => {
        button.addEventListener("click", () => {
            const parentLi = button.closest<HTMLLIElement>(".open");

            if (parentLi) {
                parentLi.classList.remove("open");
                CloseOpenNavs(parentLi);
            }
        });
    });
};

export const CloseOpenNavs = (nav: HTMLElement) => {
    const openClasses = nav.querySelectorAll(".open");
    openClasses.forEach((openClass) => {
        openClass.classList.remove("open");
    });
};

export const setHeaderActive = (header: HTMLElement) => {
    setTimeout(() => {
        header.classList.add("new-main-header--active");
    }, 1000);
}